export default {
  initDropdown: function () {
    return { show: false, timer: null, users: [], loading: false, offset: 0, hasMore: true }
  },
  methods: {
    clearTimer: function (name) {
      if (this.dropdowns[name].timer) {
        clearTimeout(this.dropdowns[name].timer)
        this.dropdowns[name].timer = null
      }
    },

    showDropdown: function (name) {
      if (this.isTouch) {
        return
      }

      this.dropdowns[name].show = true

      Object.keys(this.dropdowns).forEach((other) => {
        if (other !== name) {
          this.dropdowns[other].show = false
        }
      })

      this.clearTimer(name)
    },

    hideDropdown: function (name, event) {
      if (this.isTouch) {
        return
      }

      const delay = event ? 250 : 0 // event => mouse event, otherwise "close" event
      this.clearTimer(name)
      this.dropdowns[name].timer = setTimeout(() => { this.dropdowns[name].show = false }, delay)
    },

    toggleDropdown: function (name) {
      if (!this.isTouch) {
        return
      }

      this.dropdowns[name].show = !this.dropdowns[name].show

      Object.keys(this.dropdowns).forEach((other) => {
        if (other !== name) {
          this.dropdowns[other].show = false
        }
      })
    },

    fetchDropdown: function (name, method, params) {
      if (!this.dropdowns[name].hasMore || this.dropdowns[name].loading) {
        return true
      }
      this.dropdowns[name].loading = true
      this.$store.dispatch(method, params).then((response) => {
        if (this.dropdowns[name].offset === 0) {
          this.dropdowns[name].users = []
        }
        this.dropdowns[name].users.push.apply(this.dropdowns[name].users, response.users)
        this.dropdowns[name].hasMore = response.hasMore
        this.dropdowns[name].loading = false
        this.dropdowns[name].offset += this.fetchLimit
      }, () => {
        this.dropdowns[name].loading = false
      })
    },
    resetDropdownUsers: function (name) {
      this.dropdowns[name].offset = 0
      this.dropdowns[name].hasMore = true
    }
  }
}
